/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WarehouseInputs */

const en_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse`)
};

const es_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacén`)
};

const fr_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrepôt`)
};

const de_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lagerhalle`)
};

const ja_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`倉庫`)
};

const zh_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仓库`)
};

const ar_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستودع`)
};

const id_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gudang`)
};

const it_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magazzino`)
};

const ru_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Склад`)
};

const pt_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armazém / Galpão`)
};

const ko_val_warehouse = /** @type {(inputs: Val_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`창고`)
};

/**
* | output |
* | --- |
* | "Warehouse" |
*
* @param {Val_WarehouseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_warehouse = /** @type {((inputs?: Val_WarehouseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WarehouseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_warehouse(inputs)
	if (locale === "es") return es_val_warehouse(inputs)
	if (locale === "fr") return fr_val_warehouse(inputs)
	if (locale === "de") return de_val_warehouse(inputs)
	if (locale === "ja") return ja_val_warehouse(inputs)
	if (locale === "zh") return zh_val_warehouse(inputs)
	if (locale === "ar") return ar_val_warehouse(inputs)
	if (locale === "id") return id_val_warehouse(inputs)
	if (locale === "it") return it_val_warehouse(inputs)
	if (locale === "ru") return ru_val_warehouse(inputs)
	if (locale === "pt") return pt_val_warehouse(inputs)
	return ko_val_warehouse(inputs)
});